import { Box, styled, Typography } from '@mui/material'
import LabOrderApi from 'api/lab-order.api'
import { resetModal } from 'app/slice/modal.slice'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TextAreaInput from 'new-components/inputs/text-area-input'
import TextInput from 'new-components/inputs/text-input'
import PageModal from 'new-components/modal/page-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export const ModalCancel = styled(ModalCustom)(({ theme }) => ({
    '& .modal-dialog': { width: '600px', maxWidth: 600 }
}))

export interface ICancelLabOrderProps {
    isShow: boolean
    id: number
    labOrderNumber?: string
    onReset?: () => void
    onSuccess?: () => void
}
const initStateErrorMessage = {
    USER_NAME_STRING_EMPTY: '',
    PASSWORD_STRING_EMPTY: '',
    CANCEL_REMARK_STRING_EMPTY: '',

    NOT_FOUND_USER: '',
}
export default function CancelLabOrder(props: ICancelLabOrderProps) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [username, setUserCode] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [cancelRemark, setCancelRemark] = useState<string>('')
    const [errorMessage, setErrorMessage] = useState<any>({ ...initStateErrorMessage })

    const clearErrorMessage = async () => setErrorMessage(initStateErrorMessage)
    const resetForm = async () => {
        clearErrorMessage()
        setUserCode('')
        setPassword('')
        setCancelRemark('')
        if (props.onReset) props.onReset()
        dispatch(resetModal())
    }

    useEffect(() => {
        clearErrorMessage()
    }, [username, password, cancelRemark])

    const onDelete = (id: number) => {
        if (!username || !password || !cancelRemark) {
            setErrorMessage({
                USER_NAME_STRING_EMPTY: !username ? t('LAB_ORDER.MESSAGE.ERROR.USER_NAME_STRING_EMPTY') : '',
                PASSWORD_STRING_EMPTY: !password ? t('LAB_ORDER.MESSAGE.ERROR.PASSWORD_STRING_EMPTY') : '',
                CANCEL_REMARK_STRING_EMPTY: !cancelRemark ? t('LAB_ORDER.MESSAGE.ERROR.CANCEL_REMARK_STRING_EMPTY') : '',
            })
            return false
        }

        LabOrderApi.cancel(id, { username, password, cancelRemark })
            .then((res) => {

                if (res.status !== undefined && res.status === 200) {
                    notiSuccess(t(`LAB_ORDER.MESSAGE.SUCCESS.CANCEL`))
                    dispatch(resetModal())
                    resetForm()
                    if (props.onSuccess) props.onSuccess()

                } else {
                    const err = res.response.data
                    const errMsg: string = err?.message || ''

                    if (errMsg === 'NOT_FOUND_ORDER_PAYMENT')
                        notiError('LAB_ORDER.MESSAGE.ERROR.NOT_FOUND_ORDER_PAYMENT')
                    else if (errMsg === 'NOT_FOUND_USER')
                        setErrorMessage({
                            ...initStateErrorMessage,
                            NOT_FOUND_USER: t('LAB_ORDER.MESSAGE.ERROR.NOT_FOUND_USER'),
                        })

                }
            })
            .catch((e) => {
                const message = e?.response?.data?.message
                if (message === 'NOT_FOUND_USER' || message === 'INVALID_PASSWORD') {
                    setErrorMessage({
                        ...initStateErrorMessage,
                        NOT_FOUND_USER: message === 'NOT_FOUND_USER' ? t('LAB_ORDER.MESSAGE.ERROR.NOT_FOUND_USER') : '',
                        INVALID_PASSWORD: message === 'INVALID_PASSWORD' ? t('LAB_ORDER.MESSAGE.ERROR.INVALID_PASSWORD') : ''
                    })
                } else {
                    notiError(t('LAB_ORDER.MESSAGE.ERROR.DONT_HAVE_PERMISSION_TO_DELETE'))
                    setErrorMessage({
                        USER_NAME_STRING_EMPTY: t('LAB_ORDER.MESSAGE.ERROR.DONT_HAVE_PERMISSION_TO_DELETE')
                    })
                }
            })
    }

    return props.isShow ? (
        <PageModal
            title={t('LAB_ORDER.TITLE_CANCEL_LAB')}
            size="S"
            isOpen={props.isShow}
            handleClose={() => props.onReset && props.onReset()}
            onCancel={{ onClick: () => props.onReset && props.onReset(), title: t('MODAL.CANCEL') }}
            onSubmit={{ onClick: () => onDelete(props.id), title: t('ยืนยัน'), type: 'danger' }}
        >
            <Box display="flex" flexDirection="column" gap="16px">
                <Typography fontSize={14}>{t('LAB_ORDER.FORM.CAPTION')} {props.labOrderNumber}</Typography>
                <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                    <TextInput
                        fullWidth
                        required
                        label={t('LAB_ORDER.FORM.USER_NAME')}
                        value={username}
                        onChange={(e) => {
                            setUserCode(e.target.value)
                            setErrorMessage(initStateErrorMessage)
                        }}
                        marginBottomErrorText='8px'
                        helperText={errorMessage?.USER_NAME_STRING_EMPTY || errorMessage?.NOT_FOUND_USER || ''}
                    />
                    <TextInput
                        fullWidth
                        required
                        label={t('HOME.MODAL.CANCEL_VISIT.USER_PASSWORD')}
                        type='password'
                        onChange={(event) => {
                            setPassword(event.target.value)
                            setErrorMessage(initStateErrorMessage)
                        }}
                        value={password}
                        marginBottomErrorText='8px'
                        helperText={errorMessage?.PASSWORD_STRING_EMPTY || errorMessage?.INVALID_PASSWORD || ''}
                    />
                </Box>
                <TextAreaInput
                    fullWidth
                    required
                    label={t('LAB_ORDER.FORM.CANCEL_REMARK')}
                    onChange={(event) => {
                        setCancelRemark(event.target.value)
                        setErrorMessage(initStateErrorMessage)
                    }}
                    helperText={errorMessage?.CANCEL_REMARK_STRING_EMPTY || ''}
                />
            </Box>
        </PageModal>
    ) : <></>
}
